import { useQuerySubnetworks } from 'hb-react/shared/hooks/useQuerySubnetworks';

import SelectCore from './SelectCore';

const SelectSubnetworks = (props) => {
  const { value, ...rest } = props;

  const getDefaultPlaceholder = () => {
    const config = AlumniConnect.currentNetwork.get('user_fields_config');

    return (
      config.sub_networks_placeholder || I18n.t('web.users.search.sub_networks')
    );
  };

  const subnetworks = useQuerySubnetworks({
    fallbackData: () => null,
  });

  if (subnetworks?.length > 0) {
    return (
      <SelectCore
        results={subnetworks}
        {...rest}
        value={value?.id || value}
        placeholder={getDefaultPlaceholder()}
      />
    );
  }

  return null;
};

export default SelectSubnetworks;
